import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VSkeletonLoader,{attrs:{"loading":_vm.loading,"type":"card"}},[_c('miniCardMembre',{attrs:{"membre":_vm.infosMembre}})],1),_c('statsMembre',{attrs:{"membreId":_vm.id}}),_c('sortiesMembre',{attrs:{"membreId":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }